export default __webpack_public_path__ + "static/media/Social Links.d7338d34.svg";